import React, {useCallback, useState} from "react";
import {useRouter} from "next/router";
// @material-ui/core components
import {makeStyles} from "tss-react/mui";

// @mui/icons-material
// core components
import Header from "../components/Header/Header.js";
import Footer from "../components/Footer/Footer.js";
import Button from "../components/CustomButtons/Button.js";
import HeaderLinks from "../components/Header/HeaderLinks.js";
import Parallax from "../components/Parallax/Parallax.js";
import CustomInput from "../components/CustomInput/CustomInput.js";
import JobList from "../pages-sections/Components-Sections/jobList.js";
import JobFilters from "../pages-sections/Components-Sections/jobsDynamicSearch.js";
import logo from "../public/img/logo.png";

import styles from "../styles/jss/nextjs-material-kit/pages/jobAndCoursesStyleList.js";

// Sections for this page
import PreFooter from "../pages-sections/LandingPage-Sections/PreFooter.js";
import laptopImg from "../public/img/jobs_laptop.png";
import {useJobsGetSearchMetadataRequest} from "../request/api";
import Head from "next/head";
import JSONSchemaData from "../components/JSONSchemaData/JSONSchemaData";
import {parseAsInteger, parseAsString, useQueryState, useQueryStates} from "nuqs";
import {GPTProvider, GPTSlot} from 'goopubtag';

const dashboardRoutes = [];

const useStyles = makeStyles()(styles);

export default function LandingPage(props) {
  const { classes, cx } = useStyles();
  const router = useRouter();
  const { ...rest } = props;

  const {
    data: jobFilterMetadata,
    error,
    isLoading,
  } = useJobsGetSearchMetadataRequest();

  const [organisation, setOrganisation] = useQueryState('organisation');
  let initialFilters = {
    career_zone_ids: [],
    job_type: null,
    location_id: null,
    employer_id: organisation,
  };
  const [jobFilters, setJobFilters] = useState(initialFilters);
  const [jobQuery, setJobQuery] = useQueryStates({
    query: parseAsString.withDefault(''),
    page: parseAsInteger.withDefault(1),
  });
  const [internalJobQuery, setInternalJobQuery] = useState();
  const doJobFiltersReset = () => setJobFilters(initialFilters);
  const onJobFiltersChange = (newJobFilters) => setJobFilters(newJobFilters);


  const handleSearch = useCallback(
    async (e) => {
      e.preventDefault();

      window.gtag &&
      window.gtag("event", "job_search", {
        search_term: internalJobQuery,
      });

      setJobQuery({ query: internalJobQuery, page: 1 });
    },
    [internalJobQuery]
  );

  const jsonBreadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://successatschool.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Jobs",
        item: "https://successatschool.org/jobs",
      },
    ],
  };

  return (
    <div className={cx(classes.white_bg, "careerZoneSlide")}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        logo={logo}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Head>
        <link rel="canonical" href="https://successatschool.org/jobs" />
        <title>Jobs - Success at School</title>
      </Head>
      <Parallax
        className="parallaxx-compact"
        filter
        image="/img/faces/jobs_courses_bg.png"
      >
        <h1 className={cx(classes.title, "title")}>Latest Opportunities</h1>
        <br />
      </Parallax>

      <div className={cx(classes.section, classes.bg_colored, "jobbs")}>
        <div className={cx(classes.container, classes.relative)}>
          <div className={cx(classes.welcomeImg, "welcomeImg")}>
            <img src={laptopImg.src} width="287px" height="164px" />
          </div>
          <div style={{ minHeight: "285px" }}>
            <form
              onSubmit={handleSearch}
              id="inputs"
              className={[classes.search_section, "search_section"].join(" ")}
            >
              <h1 className={[classes.smallTitle, "title"].join(" ")}>
                Apprenticeships
              </h1>
              <p className={classes.text}>
                Search and apply for the latest opportunities
              </p>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  paddingTop: "10px",
                }}
              >
                <CustomInput
                  inputProps={{
                    value: internalJobQuery || jobQuery.query,
                    placeholder: "Job title, keywords, company",
                    className: cx(
                      classes.inputField,
                      "whatField",
                      "jobsInputField"
                    ),
                  }}
                  id="regular"
                  labelText={"What"}
                  formControlProps={{
                    onChange: (e) => setInternalJobQuery(e.target.value),
                    fullWidth: true,
                    className: cx(classes.whereField),
                  }}
                />
                <Button
                  type="submit"
                  className={cx(classes.homeSearchButton)}
                  fullWidth
                >
                  Find
                </Button>
              </div>
              {jobFilterMetadata ? (
                <JobFilters
                  jobFilters={jobFilters}
                  jobFilterMetadata={jobFilterMetadata}
                  resetJobFilters={doJobFiltersReset}
                  onJobFiltersChange={onJobFiltersChange}
                />
              ) : null}
            </form>
            <div className={classes.space70} />
            <br />
          </div>
        </div>
      </div>

      <div className={cx(classes.main)}>
        <div className={cx(classes.white_bg, "colored_bgg")}>
          <GPTProvider networkId={108480305}>
            <GPTSlot slotId="job-listing-ad" adUnit="Leaderboard_Advice" sizes={[728, 90]} fallback="expand" className={classes.advert} />
          </GPTProvider>
          <JobList jobFilters={jobFilters} jobQuery={jobQuery.query} />
        </div>
      </div>
      <div className={cx(classes.darkBlue, "footer", "colored_bgg")}>
        <PreFooter />
      </div>
      <Footer />
      <JSONSchemaData key_name={"breadcrumbSchema"} data={jsonBreadcrumbData} />
    </div>
  );
}
